import { gql } from '@apollo/client';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { UseMentionUsersServiceFragment } from '../CommentMarkdownEditor/useMentionUsers';

import { SingleProposalCommentFragment } from './SingleProposalComment';

export const NEW_COMMENT_TEMP_ID = 'temp-id';

export const ProposalCommentsParentCommentFragment = gql`
  fragment ProposalCommentsParentCommentFragment on ParentChangeProposalComment {
    id
    replyCount
    schemaCoordinate
    schemaScope
    createdAt
    outdated
  }
`;

export const UseAddCommentNewReplyChangeCommentFragment = gql`
  fragment UseAddCommentNewReplyChangeCommentFragment on ReplyChangeProposalComment {
    id
    message
    createdAt
    updatedAt
    createdBy {
      id
      ... on User {
        fullName
        avatarUrl
      }
    }
    status
  }
`;

export const UseAddCommentNewReplyGeneralCommentFragment = gql`
  fragment UseAddCommentNewReplyGeneralCommentFragment on ReplyGeneralProposalComment {
    id
    message
    createdAt
    updatedAt
    createdBy {
      id
      ... on User {
        fullName
        avatarUrl
      }
    }
    status
  }
`;

export const UseAddCommentNewChangeParentCommentFragment = gql`
  fragment UseAddCommentNewChangeParentCommentFragment on ParentChangeProposalComment {
    id
    message
    status
    replyCount
    replies {
      id
      ...UseAddCommentNewReplyChangeCommentFragment
      ...SingleProposalCommentFragment
    }
    schemaCoordinate
    schemaScope
    createdAt
    updatedAt
    createdBy {
      id
      ... on User {
        fullName
        avatarUrl
      }
    }
  }
  ${UseAddCommentNewReplyChangeCommentFragment}
  ${SingleProposalCommentFragment}
`;

export const UseAddCommentNewGeneralParentCommentFragment = gql`
  fragment UseAddCommentNewGeneralParentCommentFragment on ParentGeneralProposalComment {
    id
    message
    status
    replyCount
    replies {
      id
      ...UseAddCommentNewReplyGeneralCommentFragment
      ...SingleProposalCommentFragment
    }
    createdAt
    updatedAt
    createdBy {
      id
      ... on User {
        fullName
        avatarUrl
      }
    }
  }

  ${UseAddCommentNewReplyGeneralCommentFragment}
  ${SingleProposalCommentFragment}
`;

export const UseAddCommentProposalFragment = gql`
  fragment UseAddCommentProposalFragment on Proposal {
    id
    status
    latestRevision {
      id
    }
  }
`;

export const ProposalCommentDrawerQuery = gql<
  GraphQLTypes.ProposalCommentDrawerQuery,
  GraphQLTypes.ProposalCommentDrawerQueryVariables
>`
  query ProposalCommentDrawerQuery(
    $graphId: ID!
    $graphVariant: String!
    $commentId: ID!
    $shouldQueryComments: Boolean!
  ) {
    service(id: $graphId) {
      id
      variant(name: $graphVariant) {
        id
        proposal {
          id
          comment(id: $commentId) @include(if: $shouldQueryComments) {
            ... on NotFoundError {
              message
            }
            ...UseAddCommentNewChangeParentCommentFragment
          }
          ...UseAddCommentProposalFragment
        }
      }
      ...UseMentionUsersServiceFragment
    }
  }
  ${UseAddCommentNewChangeParentCommentFragment}
  ${UseAddCommentProposalFragment}
  ${UseMentionUsersServiceFragment}
`;
